if (!customElements.get('growing-calendar')) {
  class GrowingCalendar extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        row: '.growing-calendar__row',

        lastRowClass: 'growing-calendar__row--last',
      }

      this.markLastItem();
    }

    markLastItem() {
      const tableRows = [...this.querySelectorAll(this.selectors.row)];
      const orders = tableRows.map(row => parseInt(window.getComputedStyle(row).order) || 0);
      const allOrdersEqual = orders.every(order => order === orders[0]);
      let lastTableRow;

      if (allOrdersEqual) {
        lastTableRow = tableRows[tableRows.length - 1];
      } else {
        lastTableRow = tableRows.reduce((last, current) => {
          const lastOrder = parseInt(window.getComputedStyle(last).order) || 0;
          const currentOrder = parseInt(window.getComputedStyle(current).order) || 0;

          return currentOrder > lastOrder ? current : last;
        });
      }

      lastTableRow.classList.add(this.selectors.lastRowClass);
    }
  }

  customElements.define('growing-calendar', GrowingCalendar);
}
